@if (tooltipText()) {
    <sew-button
        [icon]="icon()"
        [loading]="uploadInProgress()"
        hierarchy="secondary"
        [showIconOnly]="true"
        [oscTooltip]="tooltip"
        (click)="openFilePicker()"
    >
        <button></button>
    </sew-button>
} @else {
    <sew-button
        [icon]="icon()"
        [loading]="uploadInProgress()"
        hierarchy="secondary"
        [showIconOnly]="true"
        (click)="openFilePicker()"
    >
        <button></button>
    </sew-button>
}

<ng-template #tooltip>
    <osc-default-tooltip>
        {{ tooltipText() }}
    </osc-default-tooltip>
</ng-template>

<!-- limiting image types in accept would not bring up the gallery vs camera option -->
<input
    #fileInput
    style="display: none"
    type="file"
    accept="image/*;capture=camera"
    (change)="onFileSelected($event)"
/>
